import { type PostGamificationFormParticipationByFormIdData } from '@capsicum/common';

import { gamificationApi } from '.';

export type FetchGamificationFormByIdParams = {
	formId: string;
};

export const fetchGamificationFormById = async (
	params: FetchGamificationFormByIdParams
): Promise<PostGamificationFormParticipationByFormIdData> => {
	const api = await gamificationApi;
	const response = await api.postGamificationFormParticipationByFormId(params.formId);

	return response;
};
